//判断对象是否为空的函数。。。
function isEmptyObject(obj) {
  for (var key in obj) {
    return false
  };
  return true
};

function pushSelectMenu(selectMenuArr, element, preUrl, endName) {

  let selectMenuObj = {};
  let selectMenuSubArr = [];

  if (element.sub.length > 0) {
    selectMenuObj.name = element.title
    if (endName) {
      selectMenuObj.name = element.title + endName
    }
    element.sub.forEach(subElement => {
      if (subElement.sub.length > 0) {
        subElement.sub.forEach(thirdElement => {
          //判断是否为可调试接口
          if (thirdElement.isDebugging) {
            let selectMenuSubObj = {};
            selectMenuSubObj.name = thirdElement.title;
            if (preUrl) {
              selectMenuSubObj.value = preUrl + thirdElement.linkUrl;
            } else {
              selectMenuSubObj.value = "/openydt/api/v3/" + thirdElement.linkUrl;
            }
            selectMenuSubArr.push(selectMenuSubObj)
          }
        })
      } else {
        //判断是否为可调试接口
        if (subElement.isDebugging) {
          let selectMenuSubObj = {};
          selectMenuSubObj.name = subElement.title;
          if (preUrl) {
            selectMenuSubObj.value = preUrl + subElement.linkUrl;
          }  else {
            selectMenuSubObj.value = "/openydt/api/v3/" + subElement.linkUrl;
          }
          if (subElement.isUpward) {
            selectMenuSubObj.value = "/" + subElement.linkUrl;
          }
          selectMenuSubArr.push(selectMenuSubObj)
        }
      }
    });
    selectMenuObj.subList = selectMenuSubArr;
  }
  //判断是否有调试的接口
  if (!isEmptyObject(selectMenuObj) && !isEmptyObject(selectMenuObj.subList)) {
    selectMenuArr.push(selectMenuObj)
  }
}

export default {
  //获取选择调试的菜单选项
  selectMenuArr: state => {
    let selectMenuArr = [];

    state.menuList.forEach(element => {
      element.menu.forEach(sub => {
        pushSelectMenu(selectMenuArr, sub, element.uri, element.suffix)
      })
    })

    return selectMenuArr
  }
}



// WEBPACK FOOTER //
// ./src/vuex/getter.js